import React, { useState, useCallback, useRef } from 'react';
import PropTypes from 'prop-types';
import { Translate } from 'react-localize-redux';
import { Popover } from '@mui/material';
import Button from '../../../components/atoms/Button';
import { IconSizes, IconVariants } from '../../../components/foundations/Icon';
import css from './DimensionPicker.css';

const TRANSLATION_PREFIX = 'STATIC.PAGES.ANOMALY_ANALYSIS.FILTERS';

const DimensionDropdownItem = ({ item, onSelect }) => (
    <div className={css.dimensionDropdownItem} onClick={() => onSelect(item)}>
        <Translate id={item.display_name} />
    </div>
);

DimensionDropdownItem.propTypes = {
    item: PropTypes.shape({ name: PropTypes.string.isRequired, display_name: PropTypes.string.isRequired }).isRequired,
    onSelect: PropTypes.func.isRequired,
};

const DimensionPicker = ({ availableItems, onSelect }) => {
    const [anchorEl, setAnchorEl] = useState(null);
    const buttonRef = useRef(null);

    const handleOpen = useCallback(() => {
        setAnchorEl(buttonRef.current);
    }, []);

    const handleClose = useCallback(() => {
        setAnchorEl(null);
    }, []);

    const handleSelect = useCallback(
        item => {
            onSelect(item);
            setAnchorEl(null);
        },
        [onSelect]
    );

    return (
        <>
            <span ref={buttonRef}>
                <Button
                    type="link"
                    Icon="plus"
                    iconVariant={IconVariants.ACTIVE}
                    iconSize={IconSizes.X_SMALL}
                    className={css.addButton}
                    text={`${TRANSLATION_PREFIX}.ADD_DIMENSIONS`}
                    onClick={handleOpen}
                />
            </span>
            <Popover
                open={!!anchorEl}
                anchorEl={anchorEl}
                onClose={handleClose}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
                transformOrigin={{ vertical: 'top', horizontal: 'left' }}
                TransitionProps={{ timeout: 0 }}
                disableScrollLock
            >
                <div className={css.dimensionDropdown}>
                    {availableItems.map(item => (
                        <DimensionDropdownItem key={item.name} item={item} onSelect={handleSelect} />
                    ))}
                </div>
            </Popover>
        </>
    );
};

DimensionPicker.propTypes = {
    availableItems: PropTypes.arrayOf(
        PropTypes.shape({ name: PropTypes.string.isRequired, display_name: PropTypes.string.isRequired })
    ).isRequired,
    onSelect: PropTypes.func.isRequired,
};

export default DimensionPicker;
